import { FC } from "react";
import CardImage from "./card-image";
import { twMerge } from "tailwind-merge";
import ArrowLeft from "@svg/new-design/arrow-left";
import Link from "next/link";
import { ICard } from "./types";
import { CARD_VARIANT } from "./types";
import { Button, BUTTON_COLOR, BUTTON_VARIANT } from "../button";

const CheckboxStartLearningCard: FC<ICard & { href: string }> = ({
  svg_image,
  png_image,
  slug,
  variant = CARD_VARIANT.GRID,
  type,
  title,
  href,
  isFavorite,
  id,
  festival,
  svg_featured_image,
  png_featured_image,
  ...props
}) => {
  const { sku, price } = props as ICard;
  return (
    <div
      className={twMerge(
        "rounded-8 border  border-fds-cart hover:shadow-brand-md sm:p-3  flex flex-col  p-2"
      )}
    >
      <Link href={href} prefetch={false}>
        <CardImage
          svg_image={svg_image}
          png_image={png_image}
          svg_featured_image={svg_featured_image}
          png_featured_image={png_featured_image}
          type={type}
          slug={slug}
          sku={sku || ""}
          variant={variant}
          isFavorite={isFavorite}
          id={id}
          title={title}
          changeFavorite={props.changeFavorite}
          festival={festival}
        />
        <div className="flex justify-between w-full sm:flex-row flex-col">
          <p className="title-md-demibold text-fds-primary">{title}</p>
          <p className="title-md-demibold text-fds-primary">
            {price}
            <span className="body-xxsm text-fds-secondary">تومان</span>
          </p>

          <Button
            variant={BUTTON_VARIANT.TEXT}
            color={BUTTON_COLOR.PRIMARY}
            startIcon={<ArrowLeft />}
          >
            شروع یادگیری
          </Button>
        </div>
      </Link>
    </div>
  );
};
export default CheckboxStartLearningCard;
